module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ft8nEm/tc-custom/9781452129853.jpg?1720831243008",
      "alt": "This image is the cover for the book Southern Casseroles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Southern Casseroles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("With these fifty-five satisfying recipes, this classic Southern comfort food brings the heartwarming flavor of home to any family meal or friendly gathering.")]), _c('br'), _c('br'), _vm._v("This tantalizing cookbook brings the irresistible charm of Southern culture to the dinner table by way of mouthwatering casserole dishes. Denise Gee presents fifty-five beloved classic and contemporary casserole recipes bubbling with traditions that stretch from the Bayou to the lower Appalachian Mountains."), _c('br'), _c('br'), _vm._v("To complement the chapters covering basics, easy recipes, party recipes, and side dishes, dozens of luscious photos showcase the delicious attributes of a perfect casserole. "), _c('i', [_vm._v("Southern Casseroles")]), _vm._v(" brings together the tried-and-true casseroles of the South and the endearing stories behind them.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Denise Gee, Robert M. Peacock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Denise Gee is the author of Porch Parties, Southern Cocktails, and Sweet on Texas. She lives in Dallas, Texas.Robert Peacock is a Dallas-based photographer.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0